import apiClient from '@/api/index'

export default {
  index (params) {
    return apiClient.get('/fighters', { params })
  },
  store (formData) {
    return apiClient.post('/fighters', formData)
  },
  show (id, params) {
    return apiClient.get(`/fighters/${id}`, { params })
  },
  update (id, formData) {
    formData.append('_method', 'PUT')
    return apiClient.post(`/fighters/${id}`, formData)
  },
  destroy (id) {
    return apiClient.delete(`/fighters/${id}`)
  }
}
